import React from "react"
import AtelierV2 from "./AtelierV2"

/**
 * Wrapper de AtelierV2 (route principale `/atelier/fiche/:id`).
 *
 * AtelierV2 lit ses permissions directement via useAtelierPermissions(), donc
 * ce wrapper se contente de propager les props de routing. Il reste homogène
 * (AtelierWrapper, la fiche legacy, est supprimé depuis le 29.07.2026).
 */
const AtelierWrapperV2 = (props) => {
	return <AtelierV2 {...props} />
}

export default AtelierWrapperV2
